import { type ParentId, type Ymd } from './dates';

const HEADINGS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export function MonthGrid({
  days,
  padStart,
  names,
}: {
  days: { date: Ymd; parent: ParentId }[];
  padStart: number;
  names: { A: string; B: string };
}) {
  return (
    <div>
      <div className='grid grid-cols-7 gap-1 text-center text-xs font-medium uppercase text-gray-500'>
        {HEADINGS.map((label) => (
          <div key={label} className='py-1'>
            {label}
          </div>
        ))}
      </div>
      <div className='grid grid-cols-7 gap-1'>
        {Array.from({ length: padStart }).map((_, index) => (
          <div key={`pad-${index}`} />
        ))}
        {days.map(({ date, parent }) => (
          <div
            key={`${date.year}-${date.month}-${date.day}`}
            className={`min-h-[4.5rem] rounded-lg border px-2 py-1 text-left ${
              parent === 'A' ? 'border-teal-200 bg-teal-50' : 'border-sky-200 bg-sky-50'
            }`}
          >
            <p className='text-sm font-semibold'>{date.day}</p>
            <p className='truncate text-xs text-gray-600'>{names[parent]}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
